
import { Close } from "@mui/icons-material";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import React from 'react'

import { Button } from "src/shared";
import { breakpoints, useMediaQuery } from "src/shared/hooks/use-media-query";
import ConflictListing from "./conflicts-listing";
const TimeOffConflicts = ({ timeOff,conflicts, onConfirm,onClose,showConfirm=true }) => {
    
   const isMobile = useMediaQuery(
    [breakpoints.mobile, breakpoints.tablet, breakpoints.desktop],
    [true, true, false],
  );
     if (!conflicts?.length) {
       return null;
     }
    
  return (
    <Dialog fullScreen={isMobile} open maxWidth="xl" className="tw-p-5">
      <DialogTitle>
        <div className="tw-flex tw-justify-between">
            <span className="tw-text-red tw-font-bold">Conflicts: <span className="tw-font-normal">{conflicts?.length}</span></span>
            <IconButton color="black" edge="end" onClick={onClose}>
              <Close />
            </IconButton>
          </div>
      </DialogTitle>
     
      <DialogContent>
         <ConflictListing timeOff={timeOff} conflicts={conflicts} showConfirmText={showConfirm} />
      </DialogContent>
      <DialogActions>
        {showConfirm && (
					<Button
						type="button"
						onClick={onConfirm}
						variant="contained"
						className="tw-w-full sm:tw-w-auto tw-bg-red tw-text-white tw-border-red"
					>
						Confirm
					</Button>
				)}
        <Button
         className="outline tw-w-full tw-mt-1 sm:tw-mt-0 sm:tw-ml-2 sm:tw-w-auto tw-outline tw-text-red tw-border-red"
        type='button'
        onClick={onClose}
        >
          {showConfirm ? "Cancel" : "Close"}
        </Button>

      </DialogActions>
       </Dialog>   
         
      
  );
}

export default TimeOffConflicts